import _ from 'lodash';
import themeStrings from './strings.json';
import baseTheme from '../base';
import faviconUri from './images/favicon.ico';
import { getAssetUrl } from '../../lib/getWLSAssetsUrl';

const navBarLogo = getAssetUrl('images/broadcasting/primary-navigation-logo.png');


const show = {
  analytics: false,
  myAccount: false,
  newsletter: false,
  logout: true,
  partners: false,
  faq: false,
  permissions: {
    toggleAll: false,
    singleChannelToggle: true
  },
  products: {
    permissionText: false
  },
  login: {
    email: false
  }
};

const palette = {
  red: '#eb1701',
  black: '#000000',
  bleach: '#f4f4f4',
  grey: '#e6e6e6',
  dark: '#262626',
  lightGrey: '#C6C6C6',
  shadowGrey: '#848484',
  darkGrey: '#6e7070',
  green: '#00C725',
  yellow: '#ffba09',
  purple: '#8655eb',
  white: '#ffffff',
  blue: '#3358CC',
  hoverBlue:'#254cac',
  lightBlue: '#ECF1FF',
  transparent: 'transparent'
};

const colours = {
  primary: palette.blue,
  accent: palette.black,
  link: '#111111',
  modalTextColor: '#2E2E2E',
  bg: palette.transparent,
  bgContrast:palette.transparent,
  black: palette.black,
  blue: palette.blue,
  white: palette.white,
  muted: palette.darkGrey,
  border: palette.lightGrey,
  hover: palette.hoverBlue,
  positive: palette.purple,
  alert: palette.black,
  banner: {
    background: palette.lightBlue,
    primary: palette.black,
    secondary: palette.black
  },
  dark: palette.hoverBlue
};

const toggle = {
  checked: {
    track: palette.blue
  },
  default: {
    colour: palette.lightGrey,
    shadow: `0px 2px 4px 0px ${palette.shadowGrey}`
  }
};

const borders = {
  radius: '8px',
  default: `1px solid ${colours.border}`
};

const assets = {
  brand: navBarLogo,
  favicon: faviconUri
};

const whitespace = {
  xs: '5px',
  small: '15px',
  base: '20px',
  large: '32px',
  xl: '40px',
  addon: '5px',
  gutter: 0
};

const type = {
  base: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    color: colours.black,
    fontWeight: '700',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 'normal',
    textAlign: 'left'
  },

  h1: {
    fontFamily: 'Montserrat',
    fontSize: '25px',
    fontWeight: '400',
    color: colours.black,
    margin: `${whitespace.small} 0`,
    padding: 0,
    lineHeight: '110%'
  },

  h2: {
    fontFamily: 'Montserrat',
    fontSize: '25px',
    fontWeight: '600',
    color: colours.black,
    margin: 0,
    padding: 0,
    lineHeight: '1em',
    textAlign: 'center'
  },

  h3: {
    fontFamily: 'Roboto',
    color: colours.black,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '24px'
  },

  modal: {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    padding: '0',
    margin: '0 0 12px 0',
    maxWidth: '407px',
    color: colours.modalTextColor
  },

  modalh2: {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    fontWeight: '700',
    color: colours.modalTextColor,
    textAlign: 'center',
    height: '31px',
    margin: '0px 0px 8px 0px',
    lineHeight: '22px'
  },

  optOutPrimary: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '22px',
    width: '100%',
    alignSelf: 'center'
  },

  optOutSecondary: {
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: '400',
    lineHeight: '22px',
    marginBottom: '12px'
  },

  optInNoticeModal: {
    padding: '20px',
    marginBottom: '0',
    maxWidth: '336px',
    textAlign: 'center'
  },

  optInNoticeModalText: {
    fontSize: '16px',
    fontWeight: '700',
    fontFamily: 'Montserrat',
    lineHeight: '22px',
    margin: '0 0 1rem 0',
    color: colours.modalTextColor
  },

  optInNoticeModalButton: {
    fontSize: '14px',
    fontWeight: '500',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    lineHeight: '20px',
    height: '48px',
    padding: '0px',
    maxWidth: '288px',
    display:'inline-block',
    borderRadius: '8px',
    border: '1px solid',
    background: colours.blue
  },

  lead: {
    margin: 0,
    marginBottom: whitespace.base,
    fontSize: '13px'
  },

  small: {
    fontSize: '12px',
    color: colours.muted
  },

  link: {
    fontFamily: 'Montserrat',
    color: colours.link,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  linkBlock: {
    textAlign: 'left',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '20px'
  },

  button: {
    fontSize: '12px',
    background: colours.yellow
  },

  backButton: {
    fontFamily: 'Roboto-Regular',
    fontSize: '14.08px',
    fontWeight: '600px',
    color: colours.black
  },

  cancelButton: {
    color: colours.white,
    fontSize: '14px',
    fontWeight: '500',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    lineHeight: '20px',
    backgroundColor: colours.blue,
    height: '48px',
    width: '257px',
    alignSelf: 'center',
    borderRadius: '8px',
    border: '1px',
    marginBottom: '8px',
    textDecoration: 'underline'
  },

  confirmButton: {
    background: 'transparent',
    textDecoration: 'underline',
    fontWeight: '500',
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    lineHeight: '20px',
    cursor: 'pointer',
    height: '48px',
    width: '257px',
    alignSelf: 'center',
    padding: 0,
    marginBottom: '12px',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: colours.blue,
    color: colours.blue
  },

  confirmModal: {
    padding: '29px 20px 22px 20px',
    maxHeight: '315px',
    maxWidth: '439px',
    marginBottom: '0'
  },

  notice: {
    textAlign: 'center',
    fontSize: '14px'
  },

  layoutBodyMaxWidth: {
    maxWidth: '618px',
    margin: '64px 32px 0px'
  },

  layoutBody: {
    margin: '64px 32px 0px'
  },

  layoutBodyXs: {
    margin: '64px 16px 0px 32px'
  },

  productsTitle:{
    fontFamily: 'Montserrat',
    fontSize: '25px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '20px',
    marginBottom: '20px'
  },

  layoutBodyTitle: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '22px'
  },

  layoutBodyTitleLink: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '22px'
  },

  descriptionXs: {
    width: '268px',
    height: '74px',
    fontSize: '13px',
    fontFamily: 'Roboto-Regular',
    fontWeight: '400',
    lineHeight: '22px',
    padding: `0 0 10px 15px;`
  },

  descriptionSm:{
    width: '288px'
  }
};

const strings = _.merge(themeStrings, {});

export default _.merge({}, baseTheme, {
  show,
  colours,
  toggle,
  assets,
  type,
  whitespace,
  borders,
  strings
});
